import React from "react";
import PropTypes from "prop-types";

import SelectFacet from "./facet-types/select-facet";
import ScrollToFacet from "./facet-types/scroll-to-facet";
import InlineSelectFacet from "./facet-types/inline-select-facet";

const FiltersControlFacet = (props) => {
  switch (props.type) {
    case "select":
      return <SelectFacet {...props}/>
    case "scroll_to":
      return <ScrollToFacet {...props}/>
    case "inline_select":
      return <InlineSelectFacet {...props}/>
  }
};

FiltersControlFacet.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isFrontendId: PropTypes.bool,
  autoJumpToCurrentTime: PropTypes.bool,
};

export default FiltersControlFacet;
